import React, { useState } from 'react';
import { Link } from 'react-scroll'; // assuming you're using react-scroll for smooth scrolling

function NavTop() {
  const [isNavbarActive, setIsNavbarActive] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarActive(!isNavbarActive);
  };

  const closeNavbar = () => {
    if (isNavbarActive) {
      setIsNavbarActive(false);
    }
  };

  return (
    <div  className={`nav-top pt-30 pb-30 ${isNavbarActive ? 'activebg' : ''}`} >
      <div className="container">
        <div className="row">
          <div className="col-md-4 valign">
            <a href="#0" className="logo icon-img-144">
              <img src="/assets/imgs/PD-logo.svg" alt="" />
            </a>
          </div>
          <div className="col-md-4 valign">
            <div className="social text-center full-width">
              <a href="https://www.behance.net/Praveendub9cfa"><i className="fab fa-behance"></i></a>
              <a href="https://github.com/PraveenDubbaka"><i className="fab fa-github"></i></a>
              <a href="https://ca.linkedin.com/in/praveen-dubbaka-7576684"><i className="fab fa-linkedin-in"></i></a>
              <a href="https://dribbble.com/praveendubbaka"><i className="fab fa-dribbble"></i></a>
            </div>
          </div>
          <div className="col-md-4 valign">
            <div className="full-width info">
              <div className="d-flex justify-content-end">
                <a href="mailto:praveen.dubbaka@designhawks.ca">
                  <span className="sub-title fz-12">praveen.dubbaka@designhawks.ca</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="nav-butn" onClick={toggleNavbar}>
          <span className="pe-7s-menu"></span>
        </div>

        <nav className={`navbar ${isNavbarActive ? 'active display-block' : ''}`}>
          <div className="row justify-content-end rest">
            <div className="col-lg-8 rest">
              <ul className="navbar-nav main-bg d-flex justify-content-end">
                <li className="nav-item">
                  <a href="/dark">
                    <span>Home</span>
                  </a>
                </li>
                <li className="nav-item">
                  <Link to="services" spy={true} smooth={true} onClick={closeNavbar}>
                    <span>Services</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="home" spy={true} smooth={true} onClick={closeNavbar}>
                    <span>About</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="portfolio" spy={true} smooth={true} onClick={closeNavbar}>
                    <span>Portfolio</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="price" spy={true} smooth={true} onClick={closeNavbar}>
                    <span>Price</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="contact" spy={true} smooth={true} onClick={closeNavbar}>
                    <span>Contact</span>
                  </Link>
                </li>

              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default NavTop;
